/* Nomari pricing helpers (pure functions; browser: window.NomariPricing, node: require('./pricing.js')).
   Nami Light (Atash 2026-09-30 20:17 PT):
     base  = sets × setPrice
     cores = extra cores × corePrice                                   (any colour)
     panels: n = total extra panels; pattern_addon = floor(n/size)×bundlePrice + (n%size)×panelPrice
     add-ons are counted once per order (not × sets). A null price → that part (and the total) is null = TBD. */
(function (root) {
  function short$(n) { return "$" + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
  function mixMatch(o) {
    var sets = o.sets || 0, cores = o.cores || 0, n = o.panels || 0, size = o.bundleSize || 0;
    var base = o.setPrice == null ? null : sets * o.setPrice;
    var coreSub = cores ? (o.corePrice == null ? null : cores * o.corePrice) : 0;
    var bundles = 0, loose = n, patSub = 0, full = 0, save = 0;
    if (n) {
      if (o.panelPrice == null) patSub = null;
      else {
        full = n * o.panelPrice;
        if (size > 0 && o.bundlePrice != null) { bundles = Math.floor(n / size); loose = n % size; }
        patSub = bundles * (o.bundlePrice || 0) + loose * o.panelPrice;
        save = full - patSub;
      }
    }
    var addon = (coreSub === null || patSub === null) ? null : coreSub + patSub;
    var total = (base === null || addon === null) ? null : base + addon;
    // readable lines (zh + numbers); patterns line follows Atash's example wording
    var lines = [];
    if (base !== null) lines.push("套裝 " + sets + " × " + short$(o.setPrice) + " = " + short$(base));
    if (cores) lines.push("額外燈芯 " + cores + " × " + (o.corePrice == null ? "TBD" : short$(o.corePrice) + " = " + short$(coreSub)));
    if (n) {
      if (patSub === null) lines.push("額外圖案面板 " + n + " 塊 × TBD");
      else {
        var parts = [];
        if (bundles) parts.push(bundles + " 套 " + size + " 塊 bundle " + short$(bundles * o.bundlePrice));
        if (loose) parts.push(loose + " × " + short$(o.panelPrice));
        lines.push("額外圖案面板 " + n + " 塊：" + parts.join(" + ") + " = " + short$(patSub));
      }
    }
    if (save > 0) lines.push("慳 " + short$(save));
    lines.push("總數 " + (total === null ? "TBD" : short$(total)));
    var addonLines = lines.filter(function (l) { return /^額外|^慳/.test(l); });
    return { base: base, coreSub: coreSub, patSub: patSub, bundles: bundles, loose: loose, save: save,
             addon: addon, total: total, lines: lines, addonBreakdown: addonLines.join("；") };
  }
  var api = { mixMatch: mixMatch, short$: short$ };
  if (typeof module !== "undefined" && module.exports) module.exports = api; else root.NomariPricing = api;
})(this);
